import React from 'react';

export default function FallingBackground() {
  return (
    <div className="falling-bg-wrapper site-bg">
      <ul className="falling-shapes">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  );
}